<template>
    <dash
        icon="fa fa-plus-circle"
        titulo="ADITIVOS SGF"
        subTitulo="UABS"
        @click.native="$router.push({ name: 'Uabs_SolicitacoesAditivos' })"
        :qtd="qtd"
        :mostrarQtd="$temAcessoView('CRED-UABS-ADIT-01') ? true : false"
        :loading="loading"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    props: {
        qtd: {
            type: Number
        },

        loading: {
            type: Boolean
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
